import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import GhostContentAPI from '@tryghost/content-api';
import { HiMenu, HiX } from 'react-icons/hi';
import { useAuth0 } from '@auth0/auth0-react';
import Logo from '../Images/logo.png';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Article = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const { loginWithRedirect } = useAuth0();
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const navigate = useNavigate();

    const api = new GhostContentAPI({
        url: "https://trendhopper.ghost.io",
        key: "587865eb8bff414e953a4e3e99",
        version: "v5.0",
    });

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const post = await api.posts.read({ slug });
                setPost(post);
            } catch (err) {
                console.error(err);
            }
        };
        fetchPost();
    }, [slug]);

    if (!post) {
        return (
            <div className="full-page-spinner flex flex-col items-center justify-center min-h-screen bg-gray-900">
                <div className="relative w-24 h-24">
                    <img
                        src={Logo} // Replace with the actual path to your logo
                        alt="Trendhopper Logo"
                        className="absolute inset-0 m-auto w-12 h-12"
                    />
                    <div className="w-full h-full border-4 border-t-purple-500 border-r-transparent border-b-gray-600 border-l-gray-600 rounded-full animate-spin"></div>
                </div>
                <p className="text-white mt-4 text-center">Loading Trendhopper...</p>
            </div>
        );
    }

    return (
        <div className="w-full max-w-screen-lg px-4 sm:px-8 mx-auto text-black article-prose">
            <Helmet>
                <link rel="canonical" href={`https://www.trendhopper.ai/blog/${slug}`} />
            </Helmet>
            {/* Updated Header */}
            <header className="bg-white border-b border-slate-300">
                <div className="container mx-auto px-4 h-16 flex items-center justify-between">
                    <div className="flex items-center">
                        <img
                            src={Logo}
                            alt="Trendhopper"
                            className="w-10 h-10 cursor-pointer"
                            onClick={() => navigate('/')}
                        />
                        <span
                            onClick={() => navigate('/')}
                            className="font-semibold text-xl text-black cursor-pointer"
                        >
                            Trendhopper
                        </span>
                    </div>


                    <div className="hidden md:flex items-center gap-4">
                        <button
                            className="text-slate-700 hover:text-black"
                            onClick={() => loginWithRedirect()}
                            aria-label="Log in to your account"
                        >
                            Log in
                        </button>
                        <button
                            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                            onClick={() => loginWithRedirect()}
                        >
                            Start for free
                        </button>
                    </div>
                </div>
            </header>

            {isMobileMenuOpen && (
                <nav className="fixed inset-0 bg-white text-black flex flex-col items-center justify-center z-50">
                    <button
                        className="absolute top-4 right-4 text-black focus:outline-none"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        <HiX size={32} />
                    </button>
                    <div className="flex flex-col gap-4">
                        <button
                            className="text-slate-700 hover:text-black text-lg"
                            onClick={() => {
                                setIsMobileMenuOpen(false);
                                loginWithRedirect();
                            }}
                        >
                            Log in
                        </button>
                        <button
                            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                            onClick={() => {
                                setIsMobileMenuOpen(false);
                                loginWithRedirect();
                            }}
                        >
                            Start for free
                        </button>
                    </div>
                </nav>
            )}
            <div
                className="prose prose-lg mt-6 text-black max-w-none"
                dangerouslySetInnerHTML={{ __html: `<h1>${post.title}</h1>${post.html}` }}
            />

            <footer className="mt-8 bg-white text-black">
                <div className="container mx-auto px-4 lg:max-w-screen-xl xl:max-w-screen-lg py-8">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
                        <div>
                            <div className="flex justify-center md:justify-start items-center space-x-2 mb-4">
                                <img
                                    src={Logo}
                                    alt="Trendhopper"
                                    className="w-8 h-8 transition-transform hover:scale-105"
                                />
                                <span className="font-semibold text-xl">Trendhopper</span>
                            </div>
                            <p className="text-sm text-gray-700">
                                Automating SEO-optimized blog content with AI.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold mb-4">About</h3>
                            <ul className="space-y-2">
                                <li>
                                    <a href="#" className="hover:text-blue-600 transition-colors" title="Visit our blog">
                                        Blog
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="font-semibold mb-4">Follow us</h3>
                            <ul className="space-y-2">
                                <li>
                                    <a href="#" className="hover:text-blue-600 transition-colors" title="Follow us on Twitter">
                                        Twitter
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="hover:text-blue-600 transition-colors" title="Connect with us on LinkedIn">
                                        LinkedIn
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="hover:text-blue-600 transition-colors" title="Explore our GitHub">
                                        GitHub
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="border-t border-gray-300 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
                        <p className="text-sm text-gray-700">
                            © {new Date().getFullYear()} Trendhopper. All rights reserved.
                        </p>
                        <p className="text-sm text-gray-700 mt-4 md:mt-0">
                            Discover how we use AI to produce powerful blog content.{' '}
                            <a href="#" className="text-blue-600 hover:underline">
                                Start now!
                            </a>
                        </p>
                    </div>
                </div>
            </footer>


        </div>
    );
};

export default Article;
